import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { motion } from "framer-motion";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const StreakBadge = ({ stats }) => {
  const [glow, setGlow] = useState(false);
  const [prev, setPrev] = useState(stats.streak);
  useEffect(() => { if (stats.streak > prev) { setGlow(true); setTimeout(() => setGlow(false), 1600); } setPrev(stats.streak); }, [stats.streak]); // eslint-disable-line react-hooks/exhaustive-deps
  const n = stats.streak || 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <motion.button animate={glow ? { scale: [1, 1.15, 1] } : {}} transition={{ duration: 0.7 }}
          className={`shrink-0 whitespace-nowrap inline-flex items-center gap-1.5 rounded-full border px-3 h-9 text-xs transition-shadow ${n ? "border-orange-400/40 text-orange-200 bg-orange-500/10" : "border-line text-slate-400"} ${glow ? "shadow-[0_0_24px_rgba(251,146,60,0.6)]" : ""}`} data-testid="streak-badge">
          <Flame className={`w-4 h-4 ${n ? "text-orange-400" : "text-slate-500"}`} /><span data-testid="streak-count">{n}<span className="hidden sm:inline"> {n === 1 ? "day" : "days"}</span></span>
        </motion.button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 bg-panel border-line text-sm space-y-2" data-testid="streak-details">
        <p className="text-slate-200">Current streak: <span className="text-orange-300" data-testid="streak-current">{n} {n === 1 ? "day" : "days"}</span></p>
        <p className="text-slate-400">Best ever: <span className="text-amber-200" data-testid="streak-best">{stats.best || 0} {stats.best === 1 ? "day" : "days"}</span></p>
        <p className="text-slate-400" data-testid="streak-rest">{stats.rest_used ? "This week's rest day is used." : "You still have this week's rest day."}</p>
        <p className="text-[11px] text-slate-500">A day counts when you reach that day's goal. One missed day a week (Mon–Sun) won't break it.</p>
      </PopoverContent>
    </Popover>
  );
};
